
import React, { useState, useEffect, useMemo, useRef, Suspense } from 'react'
import { Login, Register, Purchase, Auth, PasswordReset } from '@cleeng/mediastore-sdk';
import { useParams, useHistory } from 'react-router-dom';
import Header from '../../components/Checkout/Header';
import checkout_svc from '../../services/checkout';
import docket from '../../docket-no-svc';
import { createGlobalStyle } from 'styled-components';
import nmx_svc from '../../newsmax-svc.js'
import { take } from 'rxjs/operators';
import CleengFooter from '../../components/Footer/CleengFooter.js';
import { Config } from "@cleeng/mediastore-sdk";
//import { localstorage_wrapper } from '../../services/localstorage_svc';
import ShippingDetailsComponent from '../../components/Checkout/ShippingDetail';
import { EMPTY_SHIPPING_DETAILS, validateShippingDetails } from '../../components/Checkout/shipping-validation';
import { getPromotion, OfferBoxSkeleton } from '../../components/Promotions';
import { handleNav } from '../../Utils';

const CheckoutStyles = createGlobalStyle`
  [class*="msd__deliveryDetails"] { display: none !important; }
  [class*="msd__section-header"] {display: none !important;}
  [class*="msd__checkout-wrapper"] {
    #display: none !important;
    padding: 0px !important;
    align-items: center;
    display: flex;
    flex-direction: column;
    border-bottom: 0px !important;
  }
  [class*="msd__price-summary"] { display: none !important; }
  [class*="msd__coupon-input__wrapper"] { display: none !important;}
  [class*="msd__offer-card"] { max-width: 400px;}
  [class*="msd__payment"] { padding: 0px !important; }
  .head-line {
     color:#515364 !important;
     font-size: calc(1.275rem + .3vw) !important;
     text-align: center !important;
  }
  div.sc-iMTnTL header { display: none !important; }
  .jVwNFFnmp {
    display: flex;
    position: relative;
    padding: 0px 40px;
    background-color: rgb(248, 250, 253);
    border-bottom: 1px solid rgb(211, 219, 230);
    text-align: center;
  }
  .CSqMYnmp {
    height: 80px;
    width: 100%;
    background-size: auto 35%;
    background-position: center center;
    background-repeat: no-repeat;
   }
   header.msd__header { display: none !important; }
   .mdd_offerBoxes {border-color: #3550a1 !important;color: #3550a1 !important;}
   .consents__text {
        font-size: 14px !important;
        color: #515364 !important;
        text-align: center !important;
   }
   .link-terms { color: #515364 !important; text-decoration: underline !important; }
   .options-box {
        width: 376px;
        border-color: #3550a1 !important;
        font-size: .90em;
        border-radius: 12px !important;
   }
   .md_consents__text,.top-box-border { border-top: 1px solid #d3dbe6; }
   .headline-consent-text { font-size: .80em !important;text-align: center !important; }
   .msd__subscription-price__period { display: none; }
   .text-gray {color:#515364 !important;}
   .text-red {color:#ff0000 !important;}
   .medium-text {font-size: 1em !important;}
   input.form-control {font-size: .8rem !important;}
   @keyframes skeleton-pulse {
       0% { opacity: 1; }
       50% { opacity: .4; }
       100% { opacity: 1; }
   }
   .skeleton {
       background-color: #e2e5eb;
       border-radius: 6px;
       animation: skeleton-pulse 1.4s ease-in-out infinite;
   }
   .msd__checkout-card-details__description {display: none;}
   .container{padding: 0 50px !important;}
   .msd__account__card {position: relative !important; max-width: 450px !important;margin-right: auto !important;margin-left: auto !important;margin-bottom: 50px; }
   .msd__subscriptions__wrapper {max-width: 450px !important;margin-right: auto !important;margin-left: auto !important; }
   .mw-600 { max-width:600px; }
   .text-justify { text-align: justify !important; }
   .fs-7 { font-size: 0.72em !important; }  
   @media (max-width: 600px) {
       .msd__auth-content { width: 100%; }
   }
`;

const PURCHASE_FORM_NAME = "purchase";
const REGISTER_FORM_NAME = "register";
const LOGIN_FORM_NAME = "login";
const PWD_RESET_FORM_NAME = "pwdreset";

const SUBSCRIPTION_STATUS = {
    NONE: 'none',
    ACTIVE: 'active',
    ACTIVE_CANCELED: 'active-canceled',
    EXPIRED: 'expired'
}

const CheckoutPage = () => {

    Config.setLanguage("customEn");
    Config.setTermsUrl('https://cleeng.com/cleeng-user-agreement');

    //Config.setJWT(localstorage_wrapper.get_cleeng_property("CLEENG_AUTH_TOKEN"))
    //Config.setRefreshToken(localstorage_wrapper.get_cleeng_property("CLEENG_REFRESH_TOKEN")); // optional

    const location = window.location.href || null;
    const referrer = window.document.referrer || null;

    const { promoCode } = useParams();
    const [checkoutForm, setCheckoutForm] = useState(REGISTER_FORM_NAME);
    const history = useHistory();

    const [userState, setUserState] = useState({
        checkingEligibility: true,
        isEligible: true,
        isNewSubscriber: true,
        currentSubscriptionOfferId: null,
        resume: false,
        subscriptionStatus: SUBSCRIPTION_STATUS.NONE
    });

    // Memoized so effects keyed on the promotion see a stable object.
    const promotion = useMemo(() => getPromotion(promoCode), [promoCode]);

    const [shippingDetails, setShippingDetails] = useState(EMPTY_SHIPPING_DETAILS);

    const purchaseRef = useRef(null);
    const bottomRef = useRef(null);
    const shippingErrors = validateShippingDetails(shippingDetails, { requirePhone: promotion.shipping.requirePhone });
    // Offers with no physical fulfillment skip the address form and go straight to payment.
    const isShippingValid = !promotion.shipping.required || Object.keys(shippingErrors).length === 0;

    // The Purchase widget's onSuccess callback may be captured once by the SDK and invoked later with a
    // stale closure, so read the shipping address from this ref (always current) instead of from the
    // shippingDetails variable closed over at the time onSuccess was created.
    const shippingDetailsRef = useRef(shippingDetails);
    useEffect(() => {
        shippingDetailsRef.current = shippingDetails;
    }, [shippingDetails]);

    useEffect(() => {
        if (promotion.shipping.required && isShippingValid && bottomRef.current) {
            bottomRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [isShippingValid, promotion.shipping.required]);

    const isLoggedIn = Auth.isLogged();

    useEffect(() => {

        if (isLoggedIn && checkoutForm !== PURCHASE_FORM_NAME) {
            setCheckoutForm(PURCHASE_FORM_NAME);
            return;
        }

        let sub = null;
        if (isLoggedIn) {
            const checkingEligibility = false;
            // Offers that allow upgrades/switches keep existing subscribers eligible.
            const isEligible = promotion.allowsExistingSubscribers;

            sub = nmx_svc.get_subscription()
                .pipe(take(1))
                .subscribe({
                    next: (subscription) => {

                        if (subscription && subscription.responseData) {
                            const activeList = subscription.responseData.items.filter(item => item.status === "active");
                            if (activeList && activeList.length > 0) {
                                const currentActive = activeList[0];
                                setUserState(prev => { return { ...prev, checkingEligibility, isEligible, isNewSubscriber: false, currentSubscriptionOfferId: currentActive.offerId, subscriptionStatus: SUBSCRIPTION_STATUS.ACTIVE } });
                                return;
                            }
                            //if there is no active subscription, get the latest one, and get the offerid
                            const latest = subscription.responseData.items.sort((a, b) => new Date(b.startedAt * 1000) - new Date(a.startedAt * 1000))[0];
                            if (latest && latest.expiresAt && new Date(latest.expiresAt * 1000) > new Date()) {
                                setUserState(prev => { return { ...prev, checkingEligibility, isEligible, isNewSubscriber: false, currentSubscriptionOfferId: latest.offerId, resume: true, subscriptionStatus: SUBSCRIPTION_STATUS.ACTIVE_CANCELED } });
                                return;
                            }
                            setUserState(prev => { return { ...prev, checkingEligibility, subscriptionStatus: SUBSCRIPTION_STATUS.EXPIRED } });
                            return; //make sure to return before get to the next step
                        }
                        setUserState(prev => { return { ...prev, checkingEligibility } });
                    },
                    error: (ex) => {
                        console.error("Get subscription failed", ex);
                        Auth.logout(() => window.location.reload());
                    }
                });
        }

        return () => {
            sub && sub.unsubscribe();
        };

    }, [checkoutForm]);

    function Logo() { return (<header className="jVwNFFnmp"><div className="CSqMYnmp msd__header__logo"></div></header>) }

    function onSuccess() {
        const payload = {
            docketNo: docket.docket_no,
            promoCode: promoCode,
            offerId: promotion.offerId,
            orderId: checkout_svc.get_order_id(),
            shippingAddress: shippingDetailsRef.current,
            location,
            referrer,
            userAgent: window.navigator.userAgent,
        }
        const redirect = () => history.push(promotion.successPath + (docket.docket_no ? `?dkt_nbr=${docket.docket_no}` : ''));

        // Only offers with physical fulfillment have an address worth storing.
        const tasks = promotion.shipping.required
            ? [checkout_svc.post_checkout(), checkout_svc.save_shipping_address(payload)]
            : [checkout_svc.post_checkout()];

        return Promise.all(tasks).finally(redirect);
    }

    function renderForm() {
        return (
            <>
                {promotion.shipping.required &&
                    <ShippingDetailsComponent
                        shippingDetails={shippingDetails}
                        setShippingDetails={setShippingDetails}
                        errors={shippingErrors}
                        includePhone={promotion.shipping.includePhone}
                        requirePhone={promotion.shipping.requirePhone} />}

                {isShippingValid &&
                    <div ref={purchaseRef}>
                        <Purchase onSuccess={onSuccess} offerId={promotion.offerId} />
                    </div>}
                <span ref={bottomRef} id="bottom" className="mb-5"></span>
            </>
        )
    }

    return (
        <>
            <CheckoutStyles />
            {isLoggedIn && <Header isHomePage onGiftToggle={() => { }} isGiftMode={false} />}
            <div className="container">
                <Logo />
                {/* Suspense lets a promotion supply a lazy() OfferBox without the page caring. */}
                {promotion.OfferBox &&
                    <Suspense fallback={<OfferBoxSkeleton />}>
                        <promotion.OfferBox />
                    </Suspense>}
                {!isLoggedIn && <>
                    {promotion.signInHeadline}

                    {checkoutForm === LOGIN_FORM_NAME && <Login onSuccess={() => { setCheckoutForm(PURCHASE_FORM_NAME) }}
                        onRegisterClick={() => { setCheckoutForm(REGISTER_FORM_NAME) }}
                        onPasswordResetClick={() => { setCheckoutForm(PWD_RESET_FORM_NAME) }} />}

                    {checkoutForm == REGISTER_FORM_NAME && <Register onSuccess={() => { setCheckoutForm(PURCHASE_FORM_NAME) }}
                        onHaveAccountClick={() => { setCheckoutForm(LOGIN_FORM_NAME) }} />}

                    {checkoutForm === PWD_RESET_FORM_NAME && <PasswordReset onSuccess={() => { setCheckoutForm(LOGIN_FORM_NAME) }} />}
                </>}
                {isLoggedIn && <>
                    {userState.checkingEligibility && <FormSkeleton />}
                    {!userState.checkingEligibility && userState.isEligible && renderForm()}
                    {!userState.checkingEligibility && !userState.isEligible && promotion.notEligible.body}
                </>}
                <CleengFooter />
            </div>
        </>
    )
}

function FormSkeleton() {
    return (
        <div class="row gap-3 mt-4 align-items-start text-center mb-4">
            <div class="border rounded p-3 bg-body col-3 options-box mx-auto">
                <div className="skeleton mx-auto mb-2" style={{ width: '80%', height: 14 }}></div>
                <div className="skeleton mx-auto mb-3" style={{ width: '60%', height: 14 }}></div>
                <div className="skeleton mx-auto mb-2" style={{ width: '90%', height: 10 }}></div>
                <div className="skeleton mx-auto mb-2" style={{ width: '90%', height: 10 }}></div>
                <div className="skeleton mx-auto" style={{ width: '70%', height: 10 }}></div>
            </div>
        </div>
    )
}


export default CheckoutPage